import { Badge } from '@ophelos/ui/components/badge';
import type { DebtData } from '@/types';
import { DebtButton } from './DebtButton';

interface DebtGroupProps {
  title: string;
  badgeLabel: string;
  badgeVariant?: 'default' | 'success' | 'failure' | 'outline' | 'subtle' | 'warning' | 'info';
  debts: DebtData[];
  onDebtClick: (debt: DebtData) => void;
  showProgress?: boolean;
  pendingCaseIds?: readonly string[] | null;
}

export function DebtGroup({ title, badgeLabel, badgeVariant = 'default', debts, onDebtClick, pendingCaseIds }: DebtGroupProps) {
  if (debts.length === 0) return null;

  return (
    <div className="stack gap-2">
      <div className="h-full px-2 flex items-center justify-between">
        <div className="flex items-center gap-2 font-medium">{title}</div>
        <Badge variant={badgeVariant}>{badgeLabel}</Badge>
      </div>
      <div className="flex flex-col gap-4">
        {debts.map((debt) => (
          <DebtButton key={debt.id} debt={debt} onClick={onDebtClick} pending={pendingCaseIds?.includes(debt.id) ?? false} />
        ))}
      </div>
    </div>
  );
}
